import { ls } from 'utils/my-localstorage'
import { find, forEachObjIndexed, propEq } from 'ramda'
import { useSelector } from 'react-redux'
import {
  CHECKBOX_LIST,
  DATE_INTERVAL,
  filterTypes,
  INTERVAL,
  RADIO_LIST,
  RHEOSTAT,
  SEARCH_USERS,
} from 'utils/consts'
import { getELabelsFiltersCollection } from 'utils/filtersCollections'
import { useFilterStoreData } from 'utils/hooks/useFilterStoreData'

export const useELabelsFiltersInputs = () => {
  const { storeName, filtersStorageName } = useFilterStoreData()

  const filtersFromStorage = ls.getObject(filtersStorageName)

  const filtersFromStore = useSelector(
    state => state?.tableFilters?.[storeName]?.filters
  )

  const getTableFilters = filters => {
    const inputs = []
    forEachObjIndexed((value, key) => {
      const filterFromCollection = find(propEq('filterName', key))(
        getELabelsFiltersCollection()
      )
      switch (filterFromCollection?.type) {
        case filterTypes[CHECKBOX_LIST]:
          if (value.length > 0 && value != -1) {
            inputs.push({
              listInput: {
                key: filterFromCollection?.apiFilterName,
                byName: value,
              },
            })
          }
          break
        case filterTypes[SEARCH_USERS]:
          if (value.length > 0) {
            inputs.push({
              freeListInput: {
                key: filterFromCollection?.apiFilterName,
                byName: value,
              },
            })
          }
          break
        case filterTypes[DATE_INTERVAL]:
          inputs.push({
            dateRangeInput: {
              key: filterFromCollection?.apiFilterName,
              fromDate: value?.fromDate ?? null,
              toDate: value?.toDate ?? null,
            },
          })
          break
        case filterTypes[RADIO_LIST]:
          inputs.push({
            listInput: {
              key: filterFromCollection?.apiFilterName,
              byName: value,
            },
          })
          break
        case filterTypes[RHEOSTAT]:
        case filterTypes[INTERVAL]:
          inputs.push({
            rangeInput: {
              key: filterFromCollection?.apiFilterName,
              ...value,
            },
          })
          break

        default:
          break
      }
    }, filters)
    return inputs.length ? inputs : null
  }

  return { getTableFilters, filtersFromStore, filtersFromStorage }
}
